import script from "./goRinSyo0079.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0079.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0079.vue?vue&type=style&index=0&id=5356575a&lang=scss"

const __exports__ = script;

export default __exports__